<ft-pending-changes *ngIf="isInitialized && !disabled"
                    [alwaysVisible]="alwaysVisible"
                    [canCommit]="canCommit"
                    [canCommitDraft]="canCommitDraft"
                    [validationRules]="validationRules"
                    [validationRulesAlwaysVisible]="validationRulesAlwaysVisible"
                    [message]="message"
                    [draftSaveVisible]="draftSaveVisible"
                    [cancelVisible]="cancelVisible"
                    [publishVisible]="publishVisible"
                    [totalChanges]="totalChanges"
                    [showCounter]="showCounter"
                    (cancel)="onCancel()"
                    (commit)="onCommit()"
                    (draftCommit)="onDraftCommit()"
                    [draftSaveButtonLabel]="draftSaveButtonLabel"
                    [cancelConfirmation]="cancelConfirmation"
                    [isSticky]="isSticky"
                    [loading$]="loading$">
</ft-pending-changes>
<ft-loading *ngIf="loading$ && !isInitialized && !disabled" [loading$]="loading$"></ft-loading>
<ng-content></ng-content>
